import { render, staticRenderFns } from "./Enquete-Listagem.vue?vue&type=template&id=a9b31070&"
import script from "./Enquete-Listagem.vue?vue&type=script&lang=js&"
export * from "./Enquete-Listagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Enquete-Listagem.vue"
export default component.exports